export default {
  inProgress: 'Download in progress',
  description:
    "Your download should start automatically in a few seconds. <0/> If it doesn't, please <1>click here</1> to start it manually.",
  error: {
    title: 'Something went wrong',
    description: 'Please check that the url is valid or try again later.'
  }
};
